// extracted by mini-css-extract-plugin
export default {"selectWrapper":"MultiSelect_selectWrapper__6cymp","placeholder":"MultiSelect_placeholder__mIDk7"};